import theme from 'src/theme';

export const kpiCardSx = {
    root: {
        position: 'relative',
        // The card fills its grid cell rather than its own content, so a row stays a row: one card
        // showing two currencies is taller than the rest, and without this the others keep their own
        // height and the white boxes end at four different places. The figures stay top-aligned, which
        // is what makes the first one in every card sit on the same line.
        height: '100%',
        p: 2.5,
        bgcolor: theme.palette.common.white,
        borderRadius: '14px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.06), 0 8px 20px rgba(0,0,0,0.05)',
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            width: 3,
            background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 1,
    },
    iconBox: {
        width: 32,
        height: 32,
        borderRadius: '8px',
        bgcolor: 'rgba(0, 127, 220, 0.08)',
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    label: {
        fontSize: '0.68rem',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.palette.neutral[500],
    },
    // Holds the card's figures. One is the ordinary case and the column is then inert; several stack,
    // each in the same row as a single figure would occupy.
    amounts: {
        display: 'flex',
        flexDirection: 'column',
    },
    valueRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 0.75,
        minHeight: 36,
    },
    value: {
        fontSize: '1.65rem',
        fontWeight: 700,
        color: theme.palette.neutral[800],
        letterSpacing: '-0.02em',
        lineHeight: 1.1,
    },
    unit: {
        fontSize: '0.85rem',
        fontWeight: 500,
        color: theme.palette.neutral[500],
    },
    // The hero figure on a phone: the one number the screen exists to show, at the size the design
    // gives it. Only the report page asks for it — every other caller of this card is untouched.
    heroRoot: {
        p: '14px',
    },
    heroLabel: {
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: theme.palette.neutral[500],
    },
    heroValueRow: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: '6px',
        minHeight: 36,
    },
    heroValue: {
        fontSize: '30px',
        fontWeight: 600,
        letterSpacing: '-0.025em',
        lineHeight: 1,
        color: theme.palette.text.primary,
        fontVariantNumeric: 'tabular-nums',
    },
    heroUnit: {
        fontSize: '13px',
        fontWeight: 500,
        color: theme.palette.neutral[600],
        pb: '2px',
    },
    skeleton: {
        width: '70%',
        height: 28,
        borderRadius: '6px',
        bgcolor: theme.palette.neutral[100],
        animation: 'pulse 1.4s ease-in-out infinite',
        '@keyframes pulse': {
            '0%, 100%': {opacity: 0.5},
            '50%': {opacity: 0.9},
        },
    },
};
